export const isEventForViewedClient = (eventClientId, viewedClientId) => {
  if (eventClientId === null || eventClientId === undefined) return true;
  if (viewedClientId === null || viewedClientId === undefined) return false;
  return String(eventClientId) === String(viewedClientId);
};
